module.exports = __webpack_public_path__ + "static/media/6.655d40ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/6.svg
// module id = 164
// module chunks = 0